
let Timers = {
    msgTipTimer:{
        "0":null,
    }
}

export default Timers;